// extracted by mini-css-extract-plugin
module.exports = {"fon":"Fon_fon__3ZVSo"};